var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.wxLoginVisible,"show-close":false,"center":"","width":"350px","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.wxLoginVisible=$event}}},[_c('div',{attrs:{"id":"wxLoginDom"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-577fb612","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wxLogin.vue
// module id = null
// module chunks = 